import React from 'react';
import './team.css'

import { useNavigate } from 'react-router-dom'

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Autoplay, Pagination } from 'swiper/modules';

import profile from '../../assets/profile.png'

const Team = ({teams, user}) => {
  const navigate = useNavigate()
  return (
    <div className="team__box">
      <div className="team__box-heading">
        <h4 className="team__box-title">Team members</h4>
        <span className="team__box-count">
          {teams?.filter((item)=>item?._id !== user?._id)?.length}
        </span>
      </div>
        <div className="team__box-item">
          <Swiper
            spaceBetween={30}
            centeredSlides={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            pagination={{
              clickable: true,
            }}
            loop={true}
            navigation={true}
            modules={[Autoplay, Pagination]}
            className="team__box-swiper"
          >
            {
              teams?.map((item, i)=>(
                item?._id !== user?._id &&(
                <SwiperSlide className="team__box-profile" key={i}>
                  <img src={!item?.profilePic ? profile 
                  :`https://aspomportal.netlify.app/upload/${item?.profilePic}`} 
                  alt={item?.firstName + ' ' + item?.lastName}
                  className="team__box-img" />
                  <h4 className="team__box-name">
                    {item?.firstName + ' ' + item?.lastName}
                  </h4>
                  <span className="team__box-role">
                    {item?.department + ' ' + item?.role}
                  </span>
                  <div className="team__box-buttons">
                    <button onClick= {()=>navigate(`/chat_room/${item?._id}`)} 
                    className="team__box-button button">Chat</button>
                    <button onClick= {()=>navigate(`/email`)} 
                    className="team__box-button button">Mail</button>
                  </div>
                </SwiperSlide>
                )
              ))
            }
          </Swiper>
        </div>
    </div>
  )
}

export default Team